import MultiplePlayGamePreviewData from '../../../../../tableEngine/Script/Game/Data/DataObject/PreviewData/MultiplePlayGamePreviewData';
import { PlayType } from '../../../../../tableEngine/Script/Game/Data/Model/TableModel';
import { LobbyMultiplePlayOverviewDataType, LobbyMultiplePlayPreviewDataType, LobbyMultiplePlayStatsDataType } from '../../Config/LobbyGamePreviewDataType';

enum EventType {
    PLAYER_COUNT_CHANGED = 'PLAYER_COUNT_CHANGED',
}
export default class LobbyMultiplePlayGamePreviewData extends MultiplePlayGamePreviewData implements LobbyMultiplePlayPreviewDataType {
    public static readonly EVENT_TYPE = { ...MultiplePlayGamePreviewData.EVENT_TYPE, ...EventType };

    protected _name: string = '';
    protected _displayName: string = '';
    protected _isFavorite: boolean = false;

    protected _progressiveValue: number | null = null;
    protected _playerCount: number = 0;
    protected _totalBet: number = 0;
    protected _rtp: number = 0;

    constructor(hallID: number, gameID: string, playType: PlayType, data: LobbyMultiplePlayOverviewDataType) {
        super(hallID, gameID, playType, data);
        this._name = data.Name;
        this._displayName = data.DisplayName;
        this.IsFavorite = data.IsFavorite;
    }

    public get Name() {
        return this._name;
    }

    public get DisplayName() {
        return this._displayName;
    }

    public get IsFavorite() {
        return this._isFavorite;
    }
    public set IsFavorite(value: boolean) {
        if (this._isFavorite === value) {
            return;
        }
        this._isFavorite = value;
        this.emit(LobbyMultiplePlayGamePreviewData.EVENT_TYPE.FAVORITE_STATUS_CHANGED, this._isFavorite);
    }

    public get ProgressiveValue() {
        return this._progressiveValue;
    }

    public get PlayerCount() {
        return this._playerCount;
    }
    public set PlayerCount(value: number) {
        if (this._playerCount === value) {
            return;
        }
        this._playerCount = value;
        this.emit(LobbyMultiplePlayGamePreviewData.EVENT_TYPE.PLAYER_COUNT_CHANGED, this._playerCount);
    }

    public get TotalBet() {
        return this._totalBet;
    }

    public get RTP() {
        return this._rtp;
    }

    public updateOverviewData(data: LobbyMultiplePlayOverviewDataType) {
        this._displayName = data.DisplayName;
        this._name = data.Name;
        this.IsFavorite = data.IsFavorite;
        super.updateOverviewData(data);
    }

    public updateStatsData(data: LobbyMultiplePlayStatsDataType) {
        this._progressiveValue = data.ProgressiveValue;
        this.PlayerCount = data.PlayerCount;
        this._totalBet = data.TotalBet;
        this._rtp = data.RTP;
        super.updateStatsData(data);
    }
}
